import api from '@/api/jobReferralManagement'

const state = {

}

const actions = {
  getJobReferralInfo (context, { jobId, params }) {
    return api.getJobReferralInfo(jobId, params)
  },
  submitJobReferral (context, { jobId, referralInfo }) {
    return api.submitJobReferral(jobId, referralInfo)
  },
  saveDraftJobReferral (context, { jobId, referralInfo }) {
    return api.saveDraftJobReferral(jobId, referralInfo)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
